module.exports = __webpack_public_path__ + "img/img3.0d0303c8.png";